import { render } from "./LargeFormBase.vue?vue&type=template&id=651298ed"
import script from "./LargeFormBase.vue?vue&type=script&lang=js"
export * from "./LargeFormBase.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__